module.exports = __webpack_public_path__ + "static/media/splashscreenMobile.e2edaf21.jpg";